module.exports = __webpack_public_path__ + "img/61800.f820269b.jpg";